import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { checkoutHoldSpot, startTradeSpot } from './../../../actions/checkout';
import { checkUserLoggedIn, reserveLimitReached } from './../../../utils';
import { getRequestToken } from './../../../actions';

class ReserveSpotButton extends Component {
  constructor (props) {
    super(props);
    this.handlePickSpotClick = this.handlePickSpotClick.bind(this);
  }

  handlePickSpotClick () {
    const {spotId, qualifiedSpots, reservedSpots, checkoutHoldSpot, startTradeSpot } = this.props;

    if(reserveLimitReached()){
      startTradeSpot(spotId, reservedSpots[0]);
    } else {
      checkoutHoldSpot(spotId);
    }
  }

  renderPickOrTradeSpotButton () {
    const { qualifiedSpots } = this.props;
    const className = `btn btn-primary btn-block btn-lg pull-right`;
    if(qualifiedSpots) {
      return (
        <a className={className} onClick={this.handlePickSpotClick} >
          { reserveLimitReached() ? 'Switch to this spot' : 'Pick this spot' }
        </a>
      );
    } else {
      return <div />;
    }
  }

  renderLoginButton () {
    return (
      <a className="btn btn-danger btn-block btn-lg pull-right" href="#" onClick={this.props.getRequestToken}>
        <div className="icon-m__white pull-left" />&nbsp;Login to pick
      </a>
    );
  }

  render () {
    if (this.props.isUserLoggedIn) {
      return this.renderPickOrTradeSpotButton();
    }
    return this.renderLoginButton();
  }
}

const mapStateToProps = (state) => {
  const { qualifiedSpots, reservedSpots } = state.userAccommodationInfo;
  return {
    qualifiedSpots,
    reservedSpots,
    isUserLoggedIn: checkUserLoggedIn(state.user),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({checkoutHoldSpot, startTradeSpot, getRequestToken}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ReserveSpotButton);



// WEBPACK FOOTER //
// ./src/containers/MapInfoBar/ParkingSpotInfoFooter/ReserveSpotButton.js